import React, { FC, useState } from 'react';
import s from './SymphonyHeader.scss';
import dataHooks from '../constants/data-hooks';
import OrbitMark from './OrbitMark';
import WixByLogo from '../../assets/images/symphonyLogo/wixByLogo.svg';

const HOME_URL = 'https://wix.com/symphony';

const NAV_LINKS = [
  { label: 'User stories', href: `${HOME_URL}/user-stories` },
  {
    label: 'Resources',
    href: 'https://www.wix.com/blog/explore/categories/symphony-by-wix',
  },
  { label: 'Pricing', href: `${HOME_URL}/pricing` },
];

// Both header actions land on the same Wix sign-in page and differ only by which panel it
// opens, so they share one builder. originUrl returns the visitor to the page they errored on.
const authUrl = (context: 'login' | 'signup') => {
  const params = new URLSearchParams({
    view: 'sign-up',
    sendEmail: 'true',
    loginCompName: 'SignUp_H',
    referralInfo: 'SignUp_H',
    postSignUp: 'https://www.wix.com/new/intro/',
    postLogin: 'https://manage.wix.com/account/route',
    loginDialogContext: context,
    originUrl: window.location.href,
  });
  return `https://users.wix.com/signin?${params}`;
};

const Logo: FC = () => (
  <a className={s.logo} href={HOME_URL} aria-label="Symphony, homepage">
    <span className={s.orbit}>
      <OrbitMark />
    </span>
    <span className={s.logoText}>Symphony</span>
    <span className={s.by}>By</span>
    <span className={s.wix}>
      <WixByLogo />
    </span>
  </a>
);

const SymphonyHeader: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className={s.header} data-hook={dataHooks.symphonyHeader}>
      <div className={s.island}>
        <div className={s.row}>
          <div className={s.leftGroup}>
            <Logo />
            <nav className={s.nav}>
              {NAV_LINKS.map((link) => (
                <a key={link.label} className={s.navLink} href={link.href}>
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
          <div className={s.actions}>
            <a className={s.login} href={authUrl('login')}>
              Log In
            </a>
            <a className={s.cta} href={authUrl('signup')}>
              Try for free
            </a>
            <button
              type="button"
              className={s.menuButton}
              data-hook={dataHooks.symphonyMenuButton}
              aria-label="Open navigation"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((open) => !open)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <nav className={s.mobileMenu}>
          {NAV_LINKS.map((link) => (
            <a key={link.label} className={s.mobileLink} href={link.href}>
              {link.label}
            </a>
          ))}
          <div className={s.mobileActions}>
            <a className={s.mobileLogin} href={authUrl('login')}>
              Log In
            </a>
            <a className={s.mobileCta} href={authUrl('signup')}>
              Try for free
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};

export default SymphonyHeader;
